import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { ReactComponent as SuccessCheck } from '../../images/SuccessCheck.svg';

interface FlatMintSuccessModalProps {
  open: boolean;
  onCloseModal: () => void;
}

export default function FlatMintSuccessModal(props: FlatMintSuccessModalProps) {
  const { onCloseModal, open } = props;
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onCloseModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                <div>
                  <div>
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      <div className="flex items-center justify-center space-x-2">
                        <SuccessCheck />
                        <h1 className="text-2xl font-bold">Successful mint</h1>
                      </div>
                    </Dialog.Title>
                    <div className="text-md mt-2 text-center text-black">
                      <p>Check your wallet for your NFT(s)!</p>
                      <p className="mt-2">
                        Thank you for supporting reproductive rights.
                      </p>
                      <button
                        className="mt-4 inline-flex w-32 justify-center rounded-md bg-black px-8 py-2 font-bold text-white"
                        onClick={onCloseModal}
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
